import { chart as rawChart } from '@rawgraphs/rawgraphs-core'
import { mapDataInWorker } from '../worker'
import { WEBWORKER_ACTIVE } from '../constants'
import { normalizeChartMapping } from './normalizeChartMapping'
import { annotateColorDomainAttributes } from './colorDomainAttributes'
import { CHART_IDS } from '../charts/chartIds'

export async function buildRawVizForExport({
  chart,
  dataset,
  dataTypes,
  mapping,
  visualOptions,
}) {
  if (!chart || !dataset || !dataTypes) return null
  const normalizedMapping = normalizeChartMapping(chart, mapping, dataTypes)

  const viz = rawChart(chart, {
    data: dataset,
    mapping: normalizedMapping,
    dataTypes,
    visualOptions,
  })

  const vizData = WEBWORKER_ACTIVE && chart?.metadata?.id !== CHART_IDS.FORCE_DIRECTED_GRAPH
    ? await mapDataInWorker(
        chart.metadata.name,
        {
          data: dataset,
          mapping: normalizedMapping,
          visualOptions,
          dataTypes,
        },
        chart.rawCustomChart
      )
    : viz._getVizData()

  const mountNode = document.createElement('div')
  mountNode.style.position = 'absolute'
  mountNode.style.left = '-100000px'
  mountNode.style.top = '0'
  mountNode.style.visibility = 'hidden'
  mountNode.style.pointerEvents = 'none'
  document.body.appendChild(mountNode)

  let rawViz = null
  try {
    rawViz = viz.renderToDOM(mountNode, vizData)
    const colorDimension =
      chart?.visualOptions?.colorScale?.dimension ||
      chart?.visualOptions?.color?.dimension ||
      null
    annotateColorDomainAttributes(rawViz?._node?.firstChild, chart, colorDimension)
  } finally {
    if (mountNode.parentNode) {
      mountNode.parentNode.removeChild(mountNode)
    }
  }
  if (rawViz) {
    rawViz._mappedData = vizData
  }
  return rawViz
}
